import React from 'react'
import { SplitButton, SplitButtonItem } from "@progress/kendo-react-buttons";


interface ItemModel {
    id?: number
    name: string
    icon?: number
    iconClass?:string | any
}

interface propsModel {
    items: ItemModel[],
    text?: string,
    onChange: any,
    size?: string | any,

}

function CustomSplitButton({ items, text, onChange, size }: propsModel) {
    return (
        <div className="example-col">
            <SplitButton  text={text} onItemClick={onChange} size={size} className='cancelBtn m-0'  style={{ height: "35px" }}>
                {items?.map((item) => (
                    <SplitButtonItem key={item.id} text={item.name} iconClass={item?.iconClass}/>
                ))}
            </SplitButton>
        </div>
    )
}

export default CustomSplitButton